export default function About() {

    return (
        <div className="container" >

            <div className="h-100 d-flex justify-content-center align-items-center">
                <p className='fs-3'>About Us</p>
            </div>
        </div>
    )
}
